import CTACard from '../../../components/cta-card'
import { ROUTES } from '../../../constants'

export default function CTACards() {
  return (
    <div className='cardsContainer'>
      <div className='wrapper flex justifyBetween'>
        <CTACard
          href={ROUTES.Sell}
          imgSrc='/images/car-interior.png'
          alt='car interior'
          heading='Sell your vehicle'
          description='Get started'
        />
        <CTACard
          href={ROUTES.GetVerified}
          imgSrc='/images/person-holding-phone.png'
          alt='person holding smartphone'
          heading='Become a verified user'
          description='Start verification'
        />
        <CTACard
          href={ROUTES.Contact}
          imgSrc='/images/woman-with-phone.jpg'
          alt='woman holding smartphone'
          heading='Give us a call'
          description='Call centre support'
        />
      </div>

      <style jsx>{`
        .cardsContainer {
          width: 100%;
          max-width: 166.6rem;
          margin: auto;
        }

        .wrapper {
          flex-wrap: wrap;
          width: 100%;

          :global(.cardContainer) {
            width: calc((100% - 2.9rem) / 3);
          }
        }

        @media (max-width: 1024px) {
          .cardsContainer {
            max-width: 54rem;
          }

          .wrapper {
            flex-direction: column;

            :global(.cardContainer) {
              width: 100%;
              margin: 0 0 1.7rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
